interface Props {
  label: string;
  pct: number;
  /** Optional override of the fill color (CSS var or hex). */
  color?: string;
}

export function BarRow({ label, pct, color = 'var(--accent)' }: Props) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div
      className="grid items-center text-[13px] gap-3"
      style={{ gridTemplateColumns: '160px 1fr 42px' }}
    >
      <div className="truncate text-text-2">{label}</div>
      <div
        className="h-2 rounded-full overflow-hidden"
        style={{ background: 'var(--bg-sunken)' }}
      >
        <div
          className="h-full rounded-full transition-all"
          style={{ width: `${clamped}%`, background: color }}
        />
      </div>
      <div className="text-right text-text-2 tabular-nums">{clamped}%</div>
    </div>
  );
}
